const HeaderAdmissionsOfficeDatabase = () => {
  return <div>Header Admissions Office Database</div>;
};

export default HeaderAdmissionsOfficeDatabase;
